<script setup>
import {onMounted} from "vue";

const siteUrl = document.querySelector('meta[name="site-url"]').content;
const props = defineProps({
  post: {
    type: Object,
    required: true,
  },
  isOpenMenu: {
    type: Boolean,
    required: true,
  },
  createdAt: {
    type: Date,
    required: true,
  },
  empathyCount: {
    type: Number,
    required: true,
  },
});

const emits = defineEmits([
  'show-publish-modal',
  'show-comment-setting-modal',
  'show-sns-share-modal',
  'show-delete-modal',
  'open-menu',
  'close-menu',
]);

// 疑似セレクトボックス外の要素をクリックした際、疑似セレクトボックスを非表示にする、
onMounted(() => {
  document.addEventListener('click', (event) => {
    if ( ! event.target.closest('.modSelectTrigger')) {
      emits('close-menu');
    }
  });
});
</script>

<template>
  <div class="lyRelative pBackColorWhite pBorderRadius2px">
    <a
      :href="Number(post.status) === 2 ? 'javascript:void(0)' : siteUrl+'place/'+post.id"
      :class="{lyBlock: true, pFontBlack: true, 'js-showPostButton': Number(post.status) === 2}"
      :data-id="post.id"
    >
      <div class="lyHorizontalBw">
        <div class="lyVerticalCnt lyPt4 lyPb4">
          <p
            v-if="Number(post.status) === 3"
            class="lyPr8 lyPl8 pFontRed pFontBold"
          >非公開</p>
          <p
            v-else-if="Number(post.status) === 4"
            class="lyPr8 lyPl8 pFontRed pFontBold"
          >運営により削除</p>
          <p
            v-else-if="Number(post.status) === 2"
            class="lyPr8 lyPl8 pFontDarkGreen pFontBold"
          >下書き</p>
          <p
            v-else
            class="lyPr8 lyPl8 pFontBlue pFontBold"
          >公開中</p>
          <button
            v-if="Number(post.status) === 2"
            type="button"
            class="pBackColorGray4 pBorderRadius2px"
          >
            <p class="lyW24px">
              <img
                :src="siteUrl+'images/iconEdit.svg'"
                loading="lazy"
                alt="下書きを編集する"
              >
            </p>
          </button>
        </div>
        <div class="lyPd8">
          <p class="pFontBold">{{post.nickname}}</p>
        </div>
        <div class="lyVerticalCnt">
          <p class="lyMr32 pFont12 pFontGray30"><time
            :datetime="createdAt.getFullYear()+'-'+(String(createdAt.getMonth() + 1).padStart(2, '0'))+'-'+(String(createdAt.getDate()).padStart(2, '0'))+'T'+(String(createdAt.getHours()).padStart(2, '0'))+':'+(String(createdAt.getMinutes()).padStart(2, '0'))"
            class="pFontMedium"
          >{{createdAt.getFullYear()}}.{{String(createdAt.getMonth() + 1).padStart(2, '0')}}.{{String(createdAt.getDate()).padStart(2, '0')}} {{String(createdAt.getHours()).padStart(2, '0')}}:{{String(createdAt.getMinutes()).padStart(2, '0')}}</time></p>
        </div>
      </div>
      <div class="lyPd8">
        <p class="pFontBold">{{post.user_nickname}}</p>
      </div>
      <div class="lyPd8">
        {{post.title+'　'+post.content.substring(0, 62)}}
      </div>
    </a>
    <div class="lyPd8 lyHorizontal">
      <div class="lyMr8">
        <p class="pChip dHeart mdNotBtn">
          <span class="pFont14 pFontMedium">{{post.count_empathy}}</span>
        </p>
      </div>
      <div class="lyMr8">
        <p class="pChip dComment mdNotBtn">
          <span class="pFont14 pFontMedium">{{post.count_comment}}</span>
        </p>
      </div>
      <div class="lyMr8">
        <p class="pChip dStar mdNotBtn">
          <span class="pFont14 pFontMedium">{{post.sum_point}}</span>
        </p>
      </div>
    </div>
    <div class="lyPstRightTop">
      <div :class="{modSelectTrigger: true, isShow: isOpenMenu}">
        <teleport to="body">
          <div :class="{gbModalBack: true, gbTriggerModalBack: true, isShow: isOpenMenu}"></div>
        </teleport>
        <button
          type="button"
          style="padding: 6px 8px 8px 8px;"
          @click="emits('open-menu')"
        >
          <img
            :src="siteUrl+'images/iconMore.svg'"
            width="16"
            height="16"
            loading="lazy"
            alt="投稿の設定"
          >
        </button>
        <div class="modSelectListContainer mdRight">
          <ul class="modSelectList">
            <li
              v-if="post.supplement === ''"
              class="pBorderBottom1pxSolidGray4"
            >
              <a
                :href="siteUrl+'place/'+post.id+'?supplement=1'"
                class="lyBlock lyW100 lyPt12 lyPb12 lyPr8 lyPl8 lyTextCnt pFontBold pFontBlack pHoverBackGray4"
              >投稿に補足</a>
            </li>
            <li
              v-if="Number(post.status) !== 2 && Number(post.status) !== 4"
              class="pBorderBottom1pxSolidGray4"
            >
              <button
                type="button"
                class="lyW100 lyPt12 lyPb12 lyPr8 lyPl8 lyTextCnt pFontBold pHoverBackGray4 pAnimation pCursorPointer"
                @click="emits('show-publish-modal'), emits('close-menu')"
              >公開設定</button>
            </li>
            <li
              v-if="Number(post.status) !== 2 && Number(post.status) !== 4"
              class="pBorderBottom1pxSolidGray4"
            >
              <button
                type="button"
                class="lyW100 lyPt12 lyPb12 lyPr8 lyPl8 lyTextCnt pFontBold pHoverBackGray4 pAnimation pCursorPointer"
                @click="emits('show-comment-setting-modal'), emits('close-menu')"
              >みんなからのコメント設定</button>
            </li>
            <li
              v-if="Number(post.status) === 1"
              class="pBorderBottom1pxSolidGray4"
            >
              <button
                type="button"
                class="lyW100 lyPt12 lyPb12 lyPr8 lyPl8 lyTextCnt pFontBold pHoverBackGray4 pAnimation pCursorPointer"
                @click="emits('show-sns-share-modal'), emits('close-menu')"
              >SNSで投稿をシェア</button>
            </li>
            <li
              v-if="Number(post.status) === 2"
              class="pBorderBottom1pxSolidGray4"
            >
              <button
                :data-id="post.id"
                type="button"
                class="lyW100 lyPt12 lyPb12 lyPr8 lyPl8 lyTextCnt pFontBold pHoverBackGray4 pAnimation pCursorPointer js-showPostButton"
                @click="emits('close-menu')"
              >続きを書く</button>
            </li>
            <li>
              <button
                type="button"
                class="lyW100 lyPt12 lyPb12 lyPr8 lyPl8 lyTextCnt pFontBold pHoverBackGray4 pAnimation pCursorPointer"
                @click="emits('show-delete-modal'), emits('close-menu')"
              >削除</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
